<div class="wrapper border-gray">
    <div>
        <div class="rightpart__header rightpart__header_bg-orange">Let's Get Started</div>
        <div class="rightpart__wrapper">
            <div class="QRTitleHeader">
                <img [src]="sharedDataService.assetsCdn('images/QRTitleHeader.png')" alt="" loading="lazy" />
            </div>
            <div class="QRCodePng">
                <img [src]="sharedDataService.assetsCdn(getQRCodeImage())" width="200" height="200" alt=""
                    loading="lazy" />
            </div>
            <div class="QRCode__content-header__text d-flex flex-column">
                <p>Scan Code to access the App</p>
            </div>
            <div class="QRCodeLine"> </div>
        </div>
    </div>
</div>